import React from "react";
import "../../styles/CustomControls.css";
import { SearchOutlined } from "@ant-design/icons";

const CustomSearchBar = ({
  value = "",
  onChange,
  placeholder = "Search...",
  onClear,
  className = "",
  disabled = false,
}) => {
  return (
    <div className={`rbSearchBox ${className}`}>
      <SearchOutlined className="rbSearchIcon" />

      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />

      {value && (
        <button
          type="button"
          className="rbSearchClear"
          onClick={onClear || (() => onChange(""))}
          disabled={disabled}
          aria-label="Clear search"
        >
          ⤫
        </button>
      )}
    </div>
  );
};

export default CustomSearchBar;
